
require.register("lodash-compat/array/last.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "lodash-compat");
  (function() {
    /**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

module.exports = last;
  })();
});